import { debounce } from "lodash";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { WsEventListener } from "@fidget/common/services/eventsListener";
import { ToastBarToastType, ToastMessageType } from ".";
import { IUiStore } from "./UiStore";
import { config } from "@fidget/common/config/config";

export class UiEventListener implements WsEventListener {
  debouncedAddToastBarToast = debounce(
    (message: string, type?: ToastMessageType, toastBarToastType?: ToastBarToastType) => {
      this.uiStore.addToastBarMessage(message, type, toastBarToastType);
    },
    config.services.times.disconnectNotificationDebounce
  );

  constructor(private _uiFinder: () => IUiStore, public name: string) { }

  get uiStore(): IUiStore {
    return this._uiFinder();
  }

  disconnected() {
    if (
      !this.uiStore.toastBarMessage ||
      this.uiStore.toastBarMessage.toastBarToastType !== ToastBarToastType.NoConnection
    ) {
      this.debouncedAddToastBarToast(
        intl.formatMessage("widget.error.noConnection"),
        ToastMessageType.DANGER,
        ToastBarToastType.NoConnection
      );
    }

    const currentRoom = this.uiStore.currentRoomReference;
    if (currentRoom) {
      currentRoom.chat.allPendingFailed();
    }
  }

  connected() {
    this.uiStore.removeToastBarMessageIfType(ToastBarToastType.NoConnection);
  }
}
